import React, { useState, useRef } from 'react';

import classNames from 'classnames';

import useOnClickOutside from '../../../../hooks/useOnClickOutside';
import useDropdownTriggerCoords from '../../../../hooks/useDropdownTriggerCoords';

export default function Filter({ filter, filtersState, updateFiltersState }) {
  const [areFiltersVisible, setAreFiltersVisible] = useState(false);

  const filtersRef = useRef();
  const triggerRef = useRef();

  useOnClickOutside(filtersRef, () => setAreFiltersVisible(false), triggerRef);

  const { coords, triggerHeight, triggerWidth } = useDropdownTriggerCoords(
    areFiltersVisible,
    setAreFiltersVisible,
    triggerRef
  );

  return (
    <div>
      <button
        className="w-auto flex items-center justify-center py-2 px-4 text-sm font-medium text-gray-900 focus:outline-none bg-white rounded-lg border border-gray-200 hover:bg-gray-100 hover:text-primary-700 focus:z-10 focus:ring-4 focus:ring-gray-200 dark:focus:ring-gray-700 dark:bg-gray-800 dark:text-gray-400 dark:border-gray-600 dark:hover:text-white dark:hover:bg-gray-700"
        type="button"
        onClick={() => setAreFiltersVisible((prevState) => !prevState)}
        ref={triggerRef}
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
          className="h-4 w-4 mr-2 text-gray-400"
          viewBox="0 0 20 20"
          fill="currentColor"
        >
          <path
            fillRule="evenodd"
            d="M3 3a1 1 0 011-1h12a1 1 0 011 1v3a1 1 0 01-.293.707L12 11.414V15a1 1 0 01-.293.707l-2 2A1 1 0 018 17v-5.586L3.293 6.707A1 1 0 013 6V3z"
            clipRule="evenodd"
          />
        </svg>
        {filter.title}
        <svg
          className="-mr-1 ml-1.5 w-5 h-5"
          fill="currentColor"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
        >
          <path
            clipRule="evenodd"
            fillRule="evenodd"
            d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
          />
        </svg>
      </button>
      <div
        ref={filtersRef}
        className={classNames(
          'fixed z-10 min-w-48 p-3 bg-white rounded-lg shadow dark:bg-gray-700',
          {
            block: areFiltersVisible,
            hidden: !areFiltersVisible,
          }
        )}
        style={{
          left: coords.x + (triggerWidth - filtersRef.current?.offsetWidth) / 2,
          top: coords.y + triggerHeight + 12,
        }}
      >
        <h6 className="mb-3 text-sm font-medium text-gray-900 dark:text-white">
          {filter.subTitle}
        </h6>
        <ul className="space-y-2 text-sm">
          {filter.options?.map((option) => {
            return (
              <li className="flex items-center" key={option.value}>
                <input
                  id={option.value}
                  type="checkbox"
                  value={option.value}
                  checked={filtersState[filter.title]?.includes?.(option.value)}
                  onChange={() =>
                    updateFiltersState(filter.title, option.value)
                  }
                  className="w-4 h-4 bg-gray-100 border-gray-300 rounded text-primary-600 focus:ring-primary-500 dark:focus:ring-primary-600 dark:ring-offset-gray-700 focus:ring-2 dark:bg-gray-600 dark:border-gray-500"
                />
                <label
                  htmlFor={option.value}
                  className="ml-2 text-sm font-normal text-gray-900 dark:text-gray-100"
                >
                  {option.label}
                </label>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
}
